module.exports = __webpack_public_path__ + "static/media/mastrack_logo.52a876fd.svg";